import apiTrainings from '@/api/trainings'
import {pipe, propOr} from 'ramda'
import {getFullName} from '@/helpers/utils'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  Training: null
}

export const mutationTypes = {
  updateTrainingStart: '[update trainings] Update trainings start',
  updateTrainingSuccess: '[update trainings] Update trainings success',
  updateTrainingFailure: '[update trainings] Update trainings failure',

  getTrainingStart: '[update trainings] Get trainings start',
  getTrainingSuccess: '[update trainings] Get trainings success',
  getTrainingFailure: '[update trainings] Get trainings failure'
}

export const actionTypes = {
  updateTraining: '[update trainings] Update trainings',
  getTraining: '[update trainings] Get trainings'
}

const mutations = {
  [mutationTypes.updateTrainingStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateTrainingSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateTrainingFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getTrainingStart](state) {
    state.isLoading = true
    state.Training = null
  },

  [mutationTypes.getTrainingSuccess](state, payload) {
    state.Training = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingFailure](state, payload) {
    state.error = payload
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateTraining](context, {id, trainingInput}) {
    context.commit(mutationTypes.updateTrainingStart)
    return new Promise(resolve => {
      apiTrainings
        .updateTraining(id, trainingInput)
        .then(response => {
          context.commit(mutationTypes.updateTrainingSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateTrainingFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getTraining](context, {id}) {
    context.commit(mutationTypes.getTrainingStart)
    return new Promise(resolve => {
      apiTrainings
        .getTraining(id)
        .then(response => {
          const data = pipe(propOr(null, 'data'), data => {
            data.trainers = data.trainers.map(trainer => ({
              ...trainer,
              foolName: getFullName(trainer)
            }))
            return data
          })(response)
          context.commit(mutationTypes.getTrainingSuccess, data)
          resolve(data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
